import React, { useEffect } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Notification = ({ message, type = 'success', duration = 4000, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(onClose, duration);
        return () => clearTimeout(timer);
    }, [duration, onClose]);

    return (
        <Box
            sx={{
                position: 'fixed',
                top: '1%',
                left: '50%',
                transform: 'translateX(-50%)',
                backgroundColor: type === 'success' ? '#e0ffe0' : '#ffe0e0',
                color: type === 'success' ? '#2e7d32' : '#d32f2f',
                padding: '15px 30px',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                zIndex: 1000,
                minWidth: '300px',
            }}
        >
            <CheckCircleIcon sx={{ fontSize: 36 }} />
            <Typography sx={{ fontWeight: 'bold' }}>{message}</Typography>
            <IconButton onClick={onClose} sx={{ color: type === 'success' ? '#2e7d32' : '#d32f2f' }}>
                <CloseIcon />
            </IconButton>
        </Box>
    );
};

export default Notification;
